export interface IZIndexOptions {
  ALERT_TOAST: number;
  MODAL: number;
  POPOVER: number;
  DROPDOWN: number;
  TOOLTIP: number;
}

export const Z_INDEX: IZIndexOptions = {
  DROPDOWN: 51,
  ALERT_TOAST: 50,
  MODAL: 40,
  POPOVER: 30,
  TOOLTIP: 6,
};
